module.exports = __webpack_public_path__ + "img/period.1c93a47b.jpg";